var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcChooseCardIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8597 31.0184C1.49729 30.2036 1.49729 28.1662 2.8597 27.3511L14.3733 20.4644C15.7357 19.6493 17.4388 20.668 17.4388 22.2981V36.0717C17.4388 37.7014 15.7357 38.7202 14.3733 37.9051L2.8597 31.0184Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.608 27.3228H35.8914C37.0133 27.3228 37.9229 28.2321 37.9229 29.3543C37.9229 30.4761 37.0133 31.3861 35.8914 31.3861H17.608V27.3228Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2447 8.74489C38.6071 9.55992 38.6071 11.5973 37.2447 12.4124L25.7311 19.2989C24.3687 20.1136 22.6656 19.0953 22.6656 17.4652V3.692C22.6656 2.06194 24.3687 1.04355 25.7311 1.85826L37.2447 8.74489Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4963 8.71606H4.21312C3.09112 8.71606 2.18152 9.62606 2.18152 10.7479C2.18152 11.8698 3.09112 12.7794 4.21312 12.7794H22.4963V8.71606Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcChooseCardIcon1);
export default __webpack_public_path__ + "static/media/xdc-choose-card-icon-1.34bb581822dd94031c27b27c583d9cbe.svg";
export { ForwardRef as ReactComponent };